import React from 'react';
import Autocomplete from 'react-google-autocomplete';
import './GooglePlacesAutocomplete.css';

const GooglePlacesAutocomplete = ({
  value,
  onChange,
  placeholder = "Enter address",
  className = "",
  style = {},
  onPlaceSelect = null,
  ...props
}) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const handlePlaceSelected = (place) => {
    console.log('Place selected:', place);

    if (place && place.formatted_address) {
      onChange({
        target: {
          name: props.name,
          value: place.formatted_address
        }
      });

      if (onPlaceSelect) {
        onPlaceSelect({
          address: place.formatted_address,
          placeId: place.place_id || '',
          geometry: place.geometry || {},
          addressComponents: place.address_components || []
        });
      }
    }
  };

  const handleInputChange = (e) => {
    onChange(e);
  };

  if (!apiKey) {
    return (
      <div className="google-places-autocomplete">
        <input
          type="text"
          value={value}
          onChange={handleInputChange}
          placeholder={placeholder}
          className={`places-input ${className}`}
          style={style}
          {...props}
        />
        <div className="places-error">
          <small>Google Maps API key not configured</small>
        </div>
      </div>
    );
  }

  return (
    <div className="google-places-autocomplete">
      <Autocomplete
        apiKey={apiKey}
        value={value}
        onChange={handleInputChange}
        onPlaceSelected={handlePlaceSelected}
        placeholder={placeholder}
        className={`places-input ${className}`}
        style={style}
        options={{
          componentRestrictions: { country: 'za' },
          fields: ['formatted_address', 'geometry', 'place_id', 'address_components'],
          types: ['address']
        }}
        {...props}
      />
    </div>
  );
};

export default GooglePlacesAutocomplete;
